import { SortDirection, SortField } from '@src/types/common';
import { CountrySummary } from '../country/countryApiSliceTypes';
import { PackageSummary } from '../packages/packageApiSliceTypes';
import { Region } from '../region/regionApiSliceTypes';

export enum ORDER_STATUS {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  PROCEED = 'proceed',
}

export type OrderSummary = {
  id: string;
  code: string;
  esimId: string;
  amount: number;
  feeAmount: number;
  discountAmount: number;
  taxType: string;
  taxAmount: number;
  taxPercentage: number;
  taxCountryCode: string;
  finalAmount: number;
  currency: string;
  gateway: string;
  status: ORDER_STATUS;
  createdAt: string;
  iccid: string | null;
};

export type Order = OrderSummary & {
  package: PackageSummary;
  country: CountrySummary;
  region: Region;
};

export interface CreateOrderParams {
  packageId: string;
  countryId: string;
  promoCode?: string;
}

export interface GetOrdersParams {
  acceptLanguage?: string;
  page?: number;
  limit?: number;
  sortBy?: SortDirection;
  sortOrder?: SortField;
  status?: 'pending' | 'completed' | 'failed';
  countryId?: string;
  packageId?: string;
}

export interface GetOrderParams {
  id: string;
  acceptLanguage?: string;
}

export type CreateOrderRequest = {
  packageId: string;
  countryId: string;
  promoCode?: string;
};

export type GetOrdersRequest = {
  acceptLanguage?: string;
};

export type GetOrderRequest = {
  id: string;
  acceptLanguage?: string;
};

export type CreateOrderResponse = {
  paymentUrl: string;
};

export type GetOrdersResponse = {
  items: Order[];
  limit: number;
  page: number;
  total: number;
  totalPages: number;
};
export type GetOrderResponse = Order;

export type GetPdfResponse = {
  downloadUrl: string;
};